import * as React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';

class Contact extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
	}

	componentDidMount() {
		document.title = this.props.t('contact');
	}

	render() {

		return (
			<div className="recruitment recruitmentWrap">
				<div className="bannerCover "
				     style={{ background: `url(${require('../img/demo4.jpg')}) no-repeat center center/cover` }}>
					<div className="hero-text">
						<div className="container">
							<h2 className="title">[Liên Hệ Với Chúng Tôi]</h2>
							<p className="post-type">
				          <span>
				            <a className="blank" href="#">
				              Phản hồi hoặc chia sẻ từ khách hàng về chất lượng, trải nghiệm dịch vụ.
				            </a></span></p><a className="blank" href="#">
						</a></div>
						<a className="blank" href="#">
						</a></div>
					<a className="blank" href="#">
					</a></div>
				<a className="blank" href="#">
				</a>
				<div className="contact-detail"><a className="blank" href="#">
				</a>
					<div className="container"><a className="blank" href="#">
					</a>
						<div className="row"><a className="blank" href="#">
						</a>
							<div className="col-sm-7"><a className="blank" href="#">
							</a>
								<ul className="nav nav-pills"><a className="blank" href="#">
								</a>
									<li>
										<a className="blank" href="#"/>
										<a className="active show" href="https://docs.google.com/forms/d/e/1FAIpQLSfztjxkPcFSeHBwkAEcXZ0hEPitFNTegLaXQL5dEZ2b86-z2A/viewform" target="_blank">[Cộng lắng nghe]</a>
										<p>Phản hồi hoặc chia sẻ từ khách hàng về chất lượng, trải nghiệm dịch vụ.</p>
									</li>
									<li>
										<a data-toggle="pill" href="#menu2" className="active show"> [Hợp tác] </a>
										<p>Hợp tác truyền thông: <a href="mailto:CMO@congcaphe.com" className="d-inline cl1">CMO@congcaphe.com</a></p>
										<p>Hợp tác nhượng quyền thương hiệu: <a href="mailto:FR@congcaphe.com" className="d-inline cl1">FR@congcaphe.com</a></p>
										<p>Tìm hiểu thông tin chung: <a href="INFO@congcaphe.com" className="d-inline cl1">INFO@congcaphe.com</a></p>
									</li>
								</ul>
								<div className="comparyAddress">
									<h6>CÔNG TY TNHH CỘNG CÀ PHÊ</h6>
									<p>
										Điện thoại: 02437.33.99.66 / Hotline: 091.181.11.66 <br />
										Địa chỉ: Văn phòng Cộng, số 94 Đường Láng, Đống Đa, Hà Nội <br />
									</p>
								</div>
							</div>
							<div className="col-sm-5">
							</div>
						</div>
					</div>
				</div>
			</div>

		);
	}
}

export default connect(mapStateToProps([]), mapDispatchToProps({}))(translate('translations')(Contact));



// WEBPACK FOOTER //
// ./src/containers/Contact.tsx